import { render, staticRenderFns } from "./EditShopBookingHeadcountSettings.vue?vue&type=template&id=5fb64bbb"
import script from "./EditShopBookingHeadcountSettings.vue?vue&type=script&lang=js"
export * from "./EditShopBookingHeadcountSettings.vue?vue&type=script&lang=js"
import style0 from "./EditShopBookingHeadcountSettings.vue?vue&type=style&index=0&id=5fb64bbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports